import dotenv from 'dotenv';
import { BaseLLM, BaseLLMConfig } from './base-llm';

dotenv.config({ quiet: true });

export interface OpenAILLMConfig extends BaseLLMConfig {}

/**
 * OpenAILLM class for handling AI-powered component generation and matching using OpenAI GPT models
 */
export class OpenAILLM extends BaseLLM {
	constructor(config?: OpenAILLMConfig) {
		super(config);
	}

	protected getDefaultModel(): string {
		return 'openai/gpt-4.1';
	}

	protected getDefaultFastModel(): string {
		// GPT-4o-mini is 60x cheaper than GPT-4o and faster - ideal for simple tasks
		return 'openai/gpt-4o-mini';
	}

	protected getDefaultApiKey(): string | undefined {
		return process.env.OPENAI_API_KEY;
	}

	protected getProviderName(): string {
		return 'OpenAI';
	}
}

// Export a singleton instance
export const openaiLLM = new OpenAILLM();
